// 22/10/2026 (Enzo) : bouton C4 partout où l'on achète ou se met en attente. Ajoute la lame, les néons et le défilé
// (styles : assets/rook-c4.css), y compris sur les boutons créés plus tard (sac, fenêtres).
(() => {
  const SEL = '.v2-btn--buy,.v2-bbar__buy,.cx-rook__go,.cx-fh__btn--buy';
  const run = '<span>' + '<span>WAKE THE HEAVY ·</span>'.repeat(4) + '</span>';
  const fx = '<span class="rk-c4__fx rk-c4__blade" aria-hidden="true"></span><span class="rk-c4__fx rk-c4__ring" aria-hidden="true"></span><span class="rk-c4__fx rk-c4__mq" aria-hidden="true">' + run + run + '</span>';
  const add = b => { if (b.classList.contains('rk-c4')) return; b.classList.add('rk-c4'); b.insertAdjacentHTML('beforeend', fx); };
  const scan = root => { if (root.matches?.(SEL)) add(root); root.querySelectorAll?.(SEL).forEach(add); };
  scan(document);
  new MutationObserver(ms => ms.forEach(m => m.addedNodes.forEach(n => { if (n.nodeType === 1 && !n.classList.contains('rk-c4__fx')) scan(n); })))
    .observe(document.body, { childList: true, subtree: true });
})();
